export const isRemoteAsset = asset =>
  !asset.startsWith(window.location.origin) && !asset.startsWith('data')
